<template>

    
    <div class="about-section-class" id="about-section">
        <div class="animations">
            <div class="bosque"></div>
            <div class="silueta"></div>
            <div class="luna"></div>
            <div class="estrellas"></div>
        </div>

        <div class="container">
            
            <h1>
                <span class="line">We do</span>
                <span class="line">engineering projects</span>
                <span class="line">
                    <span class="color">&</span> code.
                </span>
            </h1>
        
            <div class="buttons">
                <a href="/servicios">servicios</a>
                <a href="/contacto" class="cta">cuéntanos tu proyecto</a>
            </div>

        </div>
    </div>
 
</template>

<script>
    export default {
        name: 'About'
    }
</script>

<style>

    .luna {
        top: 0;
        right: 0;
        position: fixed;
        background: url('@/assets/img/about/moon.svg') right 150% no-repeat;
        background-image: "";
        background-size: 40% 40%;
        background-attachment: fixed;
        width: 100%;
        height: 100%;
        z-index: -1;
        opacity: 0;
        animation: luna-move-in 1.2s 1s forwards;
    }

    @keyframes luna-move-in {
        from {
            opacity: 0;
            background-position: right 150%;
        }
        to {
            opacity: 1;
            background-position: top right;
        }
    }

    .estrellas {
        content: '';
        position: absolute;
        background: url(@/assets/img/about/stars.svg);
        background-attachment: fixed;
        background-position-x: 80%;
        width: 100%;
        min-width: 100%;
        min-height: 100vh;
        max-height: 100vh;
        z-index: -2;
        opacity: 0;
        animation: estrellas-move-in 1000ms 300ms forwards;
    }

    @keyframes estrellas-move-in {
        from {
            background-position-y: -100px;
            background-position-x: -500px;
        }
        to {
            opacity: 1;
            background-position-y: 0;
        }
    }

    .bosque {
        position: absolute;
        bottom: -300px;
        left: 0;
        background: url(@/assets/img/about/trees.svg) bottom left repeat-x;
        background-size: cover;
        width: 100%;
        height: 80%;
        max-height: 80%;
        opacity: 0;
        animation: bosque-move-in 1000ms 500ms forwards;
        border-bottom: 300px solid #181d23;
    }

    @keyframes bosque-move-in {
        from {
            background-position-y: 150%;
        }
        to {
            opacity: 1;
            background-position-y: 100%;
        }
    }

    .silueta {
        position: absolute;
        bottom: 0;
        left: 0;
        background: url(@/assets/img/about/silhouette.svg) bottom left no-repeat;
        width: 50%;
        height: 50%;
        opacity: 0;
        animation: silueta-move-in 1000ms 800ms forwards;
    }

    @keyframes silueta-move-in {
        from {
            background-position-x: 0;
        }
        to {
            opacity: 1;
            background-position-x: 50%;
        }
    }


    #about-section .container {
        width: fit-content;
        position: fixed;
        right: 0;
        top: 50%;
        right: 25%;
        opacity: 0;
        transform: translate(0, -50%);
        animation: text-fade-in 1000ms 800ms forwards;
    }

    @keyframes text-fade-in {
        from {
            right: 0;
        }
        to {
            opacity: 1;
            right: 25%;
        }
    }

    #about-section .container h1 {
        font-size: 4rem;
        font-weight: normal;
        font-style: italic;
        color: #fafafa;
        line-height: 3rem;
    }

    #about-section .container h1 .line:first-child {
        margin-left: 1rem;
    }

    #about-section .container h1 .line:last-child {
        margin-left: 2rem;
    }

    #about-section .container .buttons {
        display: flex;
        margin-top: 1rem;
    }

    #about-section .container .buttons a,
    #about-section .container .buttons a:visited {
        width: 100%;
        padding: 1rem;
        border: 1px solid #fafafa;
        color: #fafafa;
        text-align: center;
        text-transform: uppercase;
        font-size: 1rem;
    }

    #about-section .container .buttons a:hover,
    #about-section .container .buttons a:active {
        border: 1px solid #22C55E;
        transform: translateY(-2px);
        box-shadow: 0 10px 100px -20px #22C55E;
    }

    #about-section .container .buttons a.cta,
    #about-section .container .buttons a.cta:visited {
        background: #22C55E;
        border: 1px solid transparent;
        color: #fafafa;
        font-weight: bold;
    }

    #about-section .container .buttons a.cta:hover,
    #about-section .container .buttons a.cta:active {
        background: transparent;
        border: 1px solid #22C55E;
    }

    #about-section .container .buttons a:first-child {
        margin-right: 1rem;
    }

    .line {
        display: block;
    }

    .color {
        color: #22C55E;
        font-style: italic;
    }

    @media only screen and (max-width: 649px) {
        #about-section .container {
            right: 50%;
            top: 10%;
            width: 80%;
            transform: translate(50%, 20%);
            animation: text-fade-in 1000ms 800ms forwards;
        }

        @keyframes text-fade-in {
            from {
                right: 0;
            }
            to {
                opacity: 1;
                right: 50%;
            }
        }

        .silhouette {
            width: 100%;
        }

    }
    #about-section {
        position: relative;
        overflow: hidden;
    }

    .animations {
        position: fixed;
        width: 100%;
        height: 100%;
    }

</style>